import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "../styles/PostSavePage.css";

const PostSavePage = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // ✅ source of truth
  const collectionName = location.state?.collectionName || null;

  return (
    <div className="post-save-page">
      <h1>
        your collection is saved
      </h1>
      <h2>
       choose what you’d like to do next
      </h2>

      <div className="post-save-actions">
         <button
          aria-label="Edit your collection"
          disabled={!collectionName}
          onClick={() =>
            navigate("/edit-collection", {
              state: { collectionName },
            })
          }
        >
          edit
        </button>
        <button
          className="publish-button"
          aria-label="View your collection"
          disabled={!collectionName}
          onClick={() =>
            navigate("/view-collection", {
              state: { collectionName },
            })
          }
        >
          view
        </button>

         <button
          aria-label="Create a new collection"
          onClick={() => navigate("/upload-collection")}
        >
          new
        </button>

        <button
          aria-label="Go to homepage"
          onClick={() => navigate("/home-page")}
        >
          home
        </button>
      </div>

      {!collectionName && (
        <p className="post-save-warning">
          couldn’t determine collection name — view & edit are disabled
        </p>
      )}
    </div>
  );
};

export default PostSavePage;
